import {useEffect, useState} from "react";

const useSectionHeight = (headerRef) => {
	const [applicationsSectionHeight, setApplicationsSectionHeight] =
		useState("300px");
	const [reviewsSectionHeight, setReviewsSectionHeight] = useState("300px");

	useEffect(() => {
		const calculateSectionHeights = () => {
			const headerHeight = headerRef.current?.offsetHeight || 60;
			const windowHeight = window.innerHeight;
			const mainContentHeight = 0.7 * (windowHeight - headerHeight - 40);

			setApplicationsSectionHeight(`${mainContentHeight / 2}px`);
			setReviewsSectionHeight(`${mainContentHeight / 2}px`);
		};

		calculateSectionHeights();

		const handleResize = () => {
			calculateSectionHeights();
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [headerRef]);

	return {applicationsSectionHeight, reviewsSectionHeight};
};

export default useSectionHeight;
